import { render, staticRenderFns } from "./TurnaProvider.vue?vue&type=template&id=3b76e2b4&scoped=true&"
import script from "./TurnaProvider.vue?vue&type=script&lang=js&"
export * from "./TurnaProvider.vue?vue&type=script&lang=js&"
import style0 from "./TurnaProvider.vue?vue&type=style&index=0&id=3b76e2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76e2b4",
  null
  
)

export default component.exports